import React from 'react';  
import { Link } from 'react-router-dom';    
import { useEffect, useState } from 'react'; 
import { getPrincipalMessage } from '../Service/Api';   
import LazyLoad from 'react-lazyload';
import Slider from "react-slick";
const PrincipalMessage = () => { 
    var settings = {
     autoplay: true,
    infinite: true, 
    autoplaySpeed: 2000,
    speed: 1500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false, 
    adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow:1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true); 
    console.log(data);
 
    useEffect(() => {
        const fetchData = async () => {
            try {
                const principalData = await getPrincipalMessage();
                setData(principalData);
                
            } catch (error) {
                console.log("Data Error", error);
            } finally{
                setLoading(false)
            }
        };
        fetchData();
    }, []);
    const emptyData = [
        { id: 1, category: "Principal", message: "message" , name: "Name", images: "https://webapi.entab.info/api/image/SJCSQP/public/Images/principal.jpg" }
     ];
    const emptyArrayData = [
        { id:1, category: "Director", message: "message" , name: "Name", images: "https://webapi.entab.info/api/image/SJCSQP/public/Images/Director.jpg" }
    ]; 
    return (

        <Slider {...settings}>
             {data?.length > 0 ? data?.filter((div) => div.category === "Principal").map((item, index) => ( 
                <div className="item" key={index}>
                <div className="message-block">
                    <div className='message-image'>
                        <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments}`} className="img-fluid"/></LazyLoad>
                        <div className='princi-Name'> 
                        <h3> {item.name} </h3>
                        <p> {item.category}</p>
                    </div>
                    </div> 
                    <div className='message-content'>
                        <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/quotes.gif" className="quotes" /> 
                        <div className="homemsgdesc"> <div dangerouslySetInnerHTML={{ __html: item.message }} /> </div>
                        <button className='button'><Link to="/PrincipalMessage">READ MORE <LazyLoad> <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/arrowicn.png" className="img-fluid"/> </LazyLoad></Link></button> 
                 </div>
              </div>
          </div> 

           )) : emptyData.map((data, item) => ( 
            <div className="item" key={item.id} >
                <div className="message-block">
                    <div className='message-image'>
                        <LazyLoad><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/dummy.jpg" className="img-fluid"/></LazyLoad>
                        <div className='princi-Name'> 
                        <h3> {data.name} </h3>
                        <p> {data.category}</p>
                    </div>
                    </div> 
                    <div className='message-content'>
                        <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/quotes.gif" className="quotes" /> 
                        <div className="homemsgdesc">  <p> {data.message}</p> </div>
                        <button className='button'><Link to="/PrincipalMessage">READ MORE <LazyLoad> <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/arrowicn.png" className="img-fluid"/> </LazyLoad></Link></button> 
                </div>
            </div>
        </div> 
               ))}
           
               {data?.length > 0 ? data?.filter((div) => div.category === "Director").map((item, index) => ( 
                <div className="item" key={index}>
                    <div className="message-block">
                        <div className='message-image'>
                            <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments}`} className="img-fluid"/></LazyLoad>
                            <div className='princi-Name'> 
                            <h3> {item.name} </h3>
                            <p> {item.category}</p>
                        </div>
                        </div> 
                        <div className='message-content'>
                            <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/quotes.gif" className="quotes" /> 
                            <div className="homemsgdesc"> <div dangerouslySetInnerHTML={{ __html: item.message }} /> </div>
                            <button className='button'><Link to="/DirectorMessage">READ MORE <LazyLoad> <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/arrowicn.png" className="img-fluid"/> </LazyLoad></Link></button> 
                    </div>
                    </div>
                </div>   
               
               )) : emptyArrayData.map((data,item) => ( 
                <div className="item" key={item.id} >
                <div className="message-block">
                    <div className='message-image'>
                        <LazyLoad><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/dummy.jpg" className="img-fluid"/></LazyLoad>
                        <div className='princi-Name'> 
                        <h3> {data.name} </h3>
                        <p> {data.category}</p>
                    </div>
                    </div> 
                    <div className='message-content'>
                        <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/quotes.gif" className="quotes" /> 
                        <div className="homemsgdesc">  <p> {data.message}</p> </div>
                        <button className='button'><Link to="/DirectorMessage">READ MORE <LazyLoad> <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/arrowicn.png" className="img-fluid"/> </LazyLoad></Link></button> 
                 </div>
              </div>
          </div> 
        
                   ))}   
        </Slider>

    );
};

export default PrincipalMessage;
